import { clsx } from 'clsx'

import type { SelectOption } from './types'

interface DefaultOptionProps<T> {
  option: SelectOption<T>
  isSelected: boolean
  isHighlighted: boolean
}

export function DefaultOption<T>({ option, isSelected, isHighlighted }: DefaultOptionProps<T>): JSX.Element {
  return (
    <div
      className={clsx(
        'px-3 py-1.5 cursor-pointer',
        'transition-colors duration-150',
        isHighlighted && 'bg-accent',
        isSelected && 'bg-accent/50',
        option.disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <div className="text-sm font-medium text-foreground">
        {option.label}
      </div>
      {option.description && (
        <div className="text-xs text-muted-foreground mt-0.5">
          {option.description}
        </div>
      )}
    </div>
  )
}
